export default class Skill {
  constructor(id: number, name: string, category: string, cssClass: string) {
    this.id = id;
    this.name = name;
    this.category = category;
    this.cssClass = cssClass;
  }

  public id: number;
  public name: string;
  public category: string;
  public cssClass: string;
}
